/**
 * Use this instead of MUI chip.
 */

import {Colors} from '@wandb/common/css/globals.styles';
import React from 'react';

import {IconName} from '../Icon';
import {Tooltip} from '../Tooltip';
import * as S from './Chip.styles';

type ChipProps = {
  icon?: string | React.ReactNode;
  label: React.ReactNode;
  tooltip?: string;
  color?: string;
  backgroundColor?: string;
};

const DEFAULT_BACKGROUND_COLOR = Colors.TEAL_TRANSPARENT;
const DEFAULT_COLOR = Colors.TEAL_DARK;

export const Chip = ({
  icon,
  label,
  tooltip,
  color,
  backgroundColor,
}: ChipProps) => {
  if (typeof icon === 'string') {
    icon = <S.Icon name={icon as IconName} />;
  }
  const style = {
    backgroundColor: backgroundColor ?? DEFAULT_BACKGROUND_COLOR,
    color: color ?? DEFAULT_COLOR,
  };

  const chip = (
    <S.Chip style={style}>
      {icon}
      {label}
    </S.Chip>
  );

  if (tooltip) {
    return <Tooltip content={tooltip} trigger={chip} />;
  }
  return chip;
};
